import React from 'react';

import ReviewsTable from '../../../../modules/reviews/components/ReviewsTable';

export default function ReviewsTab() {
  return <ReviewsTable sources={['GOOGLE']} />;
}
